import React from 'react';
import CookieConsent from 'react-cookie-consent';
import PropTypes from 'prop-types';

function AlertaCookie({ cookieName, onAccept }) {
  const linkCookie = 'https://drive.google.com/file/d/1cuqpuXZx4hYfy-IMdz-2ny571G4r3iji/preview?usp=sharing';
  const linkPrivacidade = 'https://drive.google.com/file/d/1cpEw0yynpglab3zsGfMu4-zA3er1q9e5/preview?usp=sharing';

  return (
    <CookieConsent
      cookieName={cookieName}
      buttonStyle={{
        backgroundColor: '#00A89C', color: '#fff', borderRadius: '2px', width: '144px',
      }}
      enableDeclineButton
      declineButtonText="Negar"
      declineButtonStyle={{
        border: '1px solid #979797', borderRadius: '2px', color: '#000000', background: 'transparent', width: '144px',
      }}
      buttonText="Estou ciente"
      onAccept={onAccept}
      onDecline={() => {
        localStorage.clear();
      }}
      style={{
        background: '#fff',
        color: '#656668',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '21px',
        borderLeft: '6px solid #00A89C',
        alignItems: 'center',
      }}
    >
      <h3>Alerta de Cookies</h3>
      Este site usa cookies
      {' '}
      <a href={linkCookie} target="_blank" rel="noreferrer">(Ver política de cookies)</a>
      {' '}
      para mapear o uso e melhorar a experiência do usuário.
      <br />
      Ao continuar utilizando, o usuário está ciente das implicações e compartilhamento de dados.
      {' '}
      <a href={linkPrivacidade} target="_blank" rel="noreferrer">Ver política de privacidade</a>
    </CookieConsent>
  );
}

AlertaCookie.propTypes = {
  cookieName: PropTypes.string.isRequired,
  onAccept: PropTypes.func.isRequired,
};

export default AlertaCookie;
